var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4807 36.36C6.4807 38.651 6.98367 40.41 7.64086 41.4741C8.50266 42.8679 9.78773 43.4583 11.0981 43.4583C12.7882 43.4583 14.3344 43.0387 17.3138 38.918C19.7009 35.6152 22.5136 30.9787 24.4059 28.0723L27.611 23.148C29.8373 19.7283 32.4141 15.9267 35.3688 13.3498C37.7803 11.2465 40.3823 10.0781 43.0008 10.0781C47.3972 10.0781 51.5848 12.6258 54.7898 17.404C58.2973 22.6369 60 29.2282 60 36.0302C60 40.0739 59.2031 43.0451 57.8468 45.3926C56.5364 47.6627 53.9824 49.9308 49.6863 49.9308V43.4583C53.3648 43.4583 54.2829 40.0781 54.2829 36.2098C54.2829 30.6973 52.9976 24.5794 50.1663 20.2083C48.1568 17.1075 45.5529 15.213 42.6881 15.213C39.5897 15.213 37.0962 17.5498 34.294 21.717C32.8043 23.9306 31.2748 26.6285 29.5577 29.6726L27.6673 33.0216C23.8697 39.7547 22.9078 41.2882 21.0091 43.8192C17.681 48.2512 14.8395 49.9308 11.0981 49.9308C6.66023 49.9308 3.85359 48.0089 2.1157 45.113C0.696797 42.753 0 39.6567 0 36.1284L6.4807 36.36Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10962 17.8608C8.08103 13.2811 12.3687 10.0781 17.2866 10.0781C20.1349 10.0781 22.9662 10.9212 25.9228 13.3352C29.1567 15.9745 32.6037 20.3208 36.904 27.484L38.4462 30.0544C42.1683 36.2557 44.2861 39.4458 45.5255 40.9505C47.1197 42.8824 48.236 43.4583 49.6861 43.4583C53.3646 43.4583 54.2827 40.0781 54.2827 36.2098L59.9998 36.0302C59.9998 40.0739 59.2029 43.0451 57.8466 45.3926C56.5362 47.6627 53.9822 49.9308 49.6861 49.9308C47.0154 49.9308 44.6494 49.3507 42.0328 46.8823C40.0214 44.9878 37.6699 41.6222 35.8608 38.5966L30.4795 29.6079C27.7798 25.0969 25.3029 21.7336 23.8697 20.2102C22.328 18.5723 20.3456 16.5942 17.1825 16.5942C14.6224 16.5942 12.4481 18.3909 10.6287 21.1387L5.10962 17.8608Z",
    fill: "url(#paint0_linear_15347_6776)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1825 16.5942C14.6224 16.5942 12.4481 18.3909 10.6287 21.1388C8.05617 25.0219 6.4807 30.8055 6.4807 36.36C6.4807 38.651 6.98367 40.41 7.64086 41.4741L2.1157 45.113C0.696797 42.753 0 39.6567 0 36.1284C0 29.7122 1.76109 23.025 5.10984 17.8608C8.08125 13.2811 12.3689 10.0781 17.2868 10.0781L17.1825 16.5942Z",
    fill: "url(#paint1_linear_15347_6776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15347_6776",
    x1: 766.875,
    y1: 2239.2,
    x2: 4893.27,
    y2: 2447.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15347_6776",
    x1: 938.932,
    y1: 2910.33,
    x2: 938.932,
    y2: 1387.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.1ec019f3ef13a94f79b1230598fc71a2.svg";
export { ForwardRef as ReactComponent };